import { Component, Input } from '@angular/core';
import { TuiIslandDirective } from '@taiga-ui/legacy';

@Component({
  selector: 'app-traitement-data',
  standalone: true,
  imports: [TuiIslandDirective],
  templateUrl: './traitement-data.component.html',
  styleUrl: './traitement-data.component.scss',
})
export class TraitementDataComponent {
  @Input() titre: string | undefined;
  @Input() sousTitre: string | undefined;
  @Input() statut: 'success' | 'warning' | 'error' | 'info' = 'info';
}
